<template>
<div>
    <SectionLayout v-for="section in page.sections" :section="section" :key="section.key"/>
    
</div>
</template>

<script>
import DataHelpers from '../helpers/DataHelpers'
import SectionLayout from './SectionLayout'
import ScreenHelpers from './ScreenHelpers'


export default {
    data() {
        return {
        
        }
    },

    components: {
        SectionLayout,
    },
    
    props: {
        page: Object,
    },

    computed: {
        valid() {
            return ScreenHelpers.isPageValid(this.page)
        }
    },

    methods: {
        function1() {

        },
    },

    created() {

    }
}
</script>

<style scoped>
   
</style>




// WEBPACK FOOTER //
// PageLayout.vue?8bf21da8